import React, { Component, useState, useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import store from '../../app/store';
import { Provider } from 'react-redux';

import { useSelector, useDispatch } from 'react-redux';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { ReactXMLViewer } from "../xxe/xeditor/xviewer";
import SplitPane, { Pane } from 'split-pane-react-uxrd';
import { UserInfo, netGet, netPost, netFetch, keycloak } from "../network";
// import { getXuiStylesheet } from "../xxe/xxeclient/xui_css";
// import { getXxeclientStylesheet } from "../xxe/xxeclient/xxeclient_css";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CircularProgress from '@mui/material/CircularProgress';

// these are observed from the XViewer external context
var iXmlDoc = null;
var iFormat = 'LIT';
var iItemId = null;
var iLinkend = null;

function InternalLinkChooserDialog (props) {
    const {
        title = 'Choose Internal Link Target Object',
        duType = 'DU',
        duMid = 'chapter',
        document,
        element, // for links
        config,  // for content inclusions or other elements
        open,
        onSave,
        onCancel,
        ...other
    } = props;
    const [docModel, setDocModel] = useState([]);
    const [selectedNode, setSelectedNode] = useState(null);
    const [selectedDU, setSelectedDU] = useState(null); // only set when opening the editor
    const [selectedItems, setSelectedItems] = useState(null);
    const [expandedItems, setExpandedItems] = useState([]);
    const [okEnabled, setOkEnabled] = useState(false);
    const [sizes, setSizes] = useState(['100%', 'auto']);
    const [format, setFormat] = useState('GEN');
    const [previewValue, setPreviewValue] = useState('');
    const [previewLabel, setPreviewLabel] = useState('Preview');
    const [previewReadOnly, setPreviewReadOnly] = useState(false);
    const [xmlContent, setXmlContent] = useState(null);
    const [linkend, setLinkend] = useState('');
    const [viewerId, setViewerId] = useState(''); // set selected id in viewer
    const [location, setLocation] = useState('');
    const [mode, setMode] = useState('LINK'); // LINK or INC


    // const editorContainer = useRef(null);

    /*
    useEffect( () => {
        
        editorContainer.current.classList.add("react-container");
        const shadowRoot = editorContainer.current.attachShadow({ mode: "open" });
        const root = createRoot(shadowRoot);
        const editor = <ReactXMLEditor readOnly={true} showHeader={false} showToolbar={false} du={selectedDU} sx={{height: '650px'}}/>;
        root.render(editor);
        
    }, []);
    */

    useEffect(() => {
        if ( open && document ) {
            setMode('LINK');
            setPreviewLabel('Preview');
            if ( config ) {
                setMode('INC');
                setPreviewLabel('Context');
            }
            setDocModel([]);
            setSelectedDU(null);
            setSelectedNode(null);
            setSelectedItems(null);
            setXmlContent(null);
            iXmlDoc = null;
            setLinkend('');
            setViewerId('');
            setLocation('');
            setSizes(['100%', 'auto']);
            setOkEnabled(false);
            let params = '';
            if ( duType && duType.length > 0 ) {
                params = '?type=' + duType;
            }
            if ( duMid && duMid.length > 0 ) {
                if ( params === '' ) {
                    params = '?mid=' + duMid;
                } else {
                    params = params + '&mid=' + duMid;
                }
            }
            let url = '/api/doc/tree/' + encodeURIComponent(document) + params;
            netGet(url)
                .then(response => response.json())
                .then(droot => {
                    if (droot) {
                        const model = [droot];
                        setDocModel(model);
                        setExpandedItems([droot.id]);
                        // setSelectedItems(null);
                        if ( iItemId ) {
                            const item = findItem(model, iItemId);
                            console.log('opening viewer... ' + iItemId);
                            setSelectedNode(item);
                            openXMLViewer(item);
                            console.log('setting viewer to ' + iLinkend);
                            setViewerId(iLinkend);
                        } else {
                            console.log('No selected item!');
                        }
                    }
                }).catch(error => {
                    console.log('Error fetching Document tree: ' + error);
                });
        } else {
            setDocModel([]);
            setSelectedDU(null);
            setSelectedNode(null);
            setExpandedItems([]);
            setSelectedItems(null);
            setSizes(['100%', 'auto']);
            setXmlContent(null);
            iXmlDoc = null;
            setViewerId('');
            setLinkend('');
            setOkEnabled(false);
            setMode('LINK');
        }
    },[open,document,duType,duMid]);

    useEffect( () => {
        if ( element ) {
            setMode('LINK');
            setPreviewLabel('Preview');
            setFormat('GEN');
            iFormat= 'GEN';
            if ( typeof element.text === 'string' && element.text.length > 0 ) {
                // this is a literal command 
                setFormat('LIT');
                iFormat = 'LIT';
                setPreviewValue(element.text);
                setPreviewLabel('Label');
                setPreviewReadOnly(false);
            } else {
                if ( element.attributes ) {
                    if ( element.attributes['preview']) {
                        setFormat('GEN');
                        iFormat = 'GEN';
                        setPreviewLabel('Preview');
                        setPreviewValue(element.attributes['preview']);
                        setPreviewReadOnly(true);
                    }
                }
            }
            iItemId = null;
            iLinkend = null;
            if ( element.attributes ) {
                if (element.attributes.linkend) {
                    setLinkend(element.attributes.linkend);
                    iLinkend = element.attributes.linkend;
                }
                if (element.attributes.location) {
                    setLocation(element.attributes.location);
                    const i = element.attributes.location.indexOf(':');
                    if ( i >= 0 ) {
                        const itemId = element.attributes.location.substring(i+1);
                        setSelectedItems(itemId);
                        // console.log('setting selectedItems: ' + itemId);
                        iItemId = itemId;
                    }
                }
            }
        }
    },[element]);

    useEffect( () => {
        if ( config ) {
            setMode('INC');
            setPreviewLabel('Context');
            parseConfig(config);
        }
    },[config]);

    const parseConfig = (cnf) => {

    };

    /*
    useEffect( () => {
        if (editorContainer.current) {
            if (!editorContainer.current.classList.contains('react-container')) {
                editorContainer.current.classList.add('react-container');
                const shadowRoot = editorContainer.current.attachShadow({ mode: "open" });
                const root = createRoot(shadowRoot);
                const editor = <ReactXMLEditor readOnly={true} showHeader={false} showToolbar={false} du={selectedDU} sx={{ height: '650px' }} />;
                root.render(editor);
            }
        }
    },[editorContainer]);
    */

    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            const entry = selectedNode?.entry ? selectedNode.entry : {};
            const du = { 
                path: selectedNode?.rootPath + '/' + entry.contentPath,
                title: selectedNode?.label,
                prefix: entry.code && entry.code !== '' && entry.code !== '-' ? entry.code + ' ' : '',
                node: selectedNode,
            };
            const res = {
                linkend: linkend,
                type: format,
                preview: previewValue,
                location: location,
                du: du,
            };
            closeXMLViewer();
            onSave(res);
        }
    }


    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        closeXMLViewer();
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const findItem = (items, id) => {
        if (Array.isArray(items)) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (id === item.id) {
                    return item;
                }
                const child = findItem(item.children, id);
                if (child) {
                    return child;
                }
            }
        }
        return undefined;
    }

    const openXMLViewer = (item) => {

        setSelectedDU(item);
        setSizes(['40%', 'auto']);
        /*
        if ( editorContainer.current ) {
            if (!editorContainer.current.classList.contains('react-container')) {
                editorContainer.current.classList.add('react-container');
                const shadowRoot = editorContainer.current.attachShadow({ mode: "open" });
                const xuiCSS = getXuiStylesheet();
                const xxeclientCSS = getXxeclientStylesheet();
                shadowRoot.adoptedStyleSheets = [xuiCSS, xxeclientCSS];
                const root = createRoot(shadowRoot);
                const editor =
                    <React.StrictMode>
                        <Provider store={store}>
                            <div style={{height: '650px', width: '600px', display: 'block'}}>
                                <ReactXMLViewer du={item} root={shadowRoot} />
                            </div>
                        </Provider>
                    </React.StrictMode>;
                root.render(editor);
            }
        }
        */
    };

    const closeXMLViewer = () => {
        setSelectedDU(null);
        setSizes(['100%', 'auto']);
    };

    const handleItemClick = (event, itemId) => {
        if (itemId === selectedItems) {
            setSelectedItems(null);
            setOkEnabled(false);
            setSelectedNode(null);
        } else {
            const item = findItem(docModel, itemId);
            if (item?.entry?.type === 'DU' || item?.entry?.type === 'PSL') {
                setSelectedItems(itemId);
                setOkEnabled(true);
                setSelectedNode(item);
                setLocation(item.document + ':' + item.id);
                setLinkend(item.id); // default, point to root 
                if ( item?.entry?.type === 'DU') {
                    console.log('Selected DU: ' + item.document + ':' + item.id);
                    openXMLViewer(item);
                } else {
                    closeXMLViewer();
                    setXmlContent(null);
                }
            } else {
                setSelectedItems(null);
                setSelectedNode(null);
                setOkEnabled(false);
                closeXMLViewer();
                setXmlContent(null);
                setLinkend('');
                setLocation('');
            }
        }
    }

    const getTopicAncestorCode = (id) => {

    };

    // get the number of this element within its sibling of the same tag
    const getNumbering = (elem) => {
        let i = 1;
        const name = elem.localName;
        let prev = elem.previousElementSibling;
        while ( prev ) {
            if ( prev.localName === name ) {
                i++;
            }
            prev = prev.previousElementSibling;
        }
        return i;
    };

    const getTitle = (elem) => {
        // console.log('getTitle: ' + elem?.localName);
        if ( elem.localName === 'title' ) {
            return elem.textContent;
        }
        let child = elem.firstElementChild;
        while ( child ) {
            if ( child.localName === 'title' ) {
                // console.log('Found title child: ' + child.textContent);
                return child.textContent;
            }
            child = child.nextElementSibling;
        }
        if ( elem.localName === 'chapter' ) {
            // special case when title is in first topic
            // console.log('Found chapter: using topic...');
            let topic = elem.firstElementChild;
            while ( topic ) {
                const t = getTitle(topic);
                if ( t != null ) {
                    return t;
                }
                topic = topic.nextElementSibling;
            }
        }
        return null;

    };

    const computePreview = (id, xml) => {
        // console.log('computePreview: ' + id + ' : ' + (xml !== null && xml !== undefined));
        if ( xml && id !== '') {
            const target = xml.getElementById(id);
            if ( target ) {
                const code = [];
                let elem = target;
                while (elem) {
                    if (elem.localName === 'chapter') {
                        const c = elem.getAttribute('code');
                        if ( c ) {
                            code.push(c);
                        }
                    } else if ( elem.localName === 'topic' && elem.parentElement?.localName !== 'chapter') {
                        const c = getNumbering(elem);
                        if ( c ) {
                            code.push(c);
                        }
                    }
                    elem = elem.parentElement;
                }
                let num = '';
                if ( code.length > 0 ) {
                    code.reverse();
                    for(let i=0; i<code.length; i++ ) {
                        if ( i > 0 ) {
                            num = num + '.';
                        }
                        num = num + code[i];
                    }
                    num = num + ' ';
                }
                let t = getTitle(target);
                if ( !t ) {
                    t = '';
                }
                const p = num + t.replaceAll(/\s+/g,' ');
                // console.log('new preview value = ' + p);
                setPreviewValue(p);

            }
        } else {

        }
    };

    const handleDocSelectionChange = (value) => {
        // console.log('Selected ID = ' + value);
        setLinkend(value);
        setOkEnabled(true);
        if ( iFormat === 'GEN' || mode === 'INC') {
            // console.log('computing preview of ' + value);
            // console.log('XML content: ' + (iXmlDoc ? iXmlDoc.documentElement?.localName : 'null'));
            computePreview(value, iXmlDoc);
        } else {
            console.log('Not computing preview: ' + format);
        }
    };

    const handleDocLoad = (docxml) => {
        const xmlParser = new DOMParser();
        const xdoc = xmlParser.parseFromString(docxml, "application/xml");
        // const items = xmlDoc.getElementsByTagName('xxe-image-viewport');
        // setXmlContent(xmlDoc);
        iXmlDoc = xdoc;
        // console.log('New XML doc content loaded');
        const root = xdoc.documentElement;
        if ( root ) {
            if ( iLinkend ) {
                setViewerId(iLinkend);
                if ( iFormat === 'GEN' ) {
                    computePreview(iLinkend, xdoc);
                }
                iLinkend = null;
            } else {
                const did = root.getAttribute('id');
                if (did) {
                    setViewerId(did);
                    // console.log('Selecting root: ' + did);
                    if (iFormat === 'GEN') {
                        computePreview(did, xdoc);
                    }
                }
            }
        }

    };

    const handleFormatChange = (event) => {
        setFormat(event.target.value);
        setOkEnabled(true);
        iFormat = event.target.value;
        // console.log('Set format to ' + event.target.value);
        if ( 'LIT' === event.target.value ) {
            setPreviewLabel('Label');
            setPreviewReadOnly(false);
        } else if ( 'GEN' === event.target.value ) {
            setPreviewLabel('Preview');
            setPreviewReadOnly(true);
            computePreview(linkend, iXmlDoc);
        }
    };

    const handlePreviewChange = (event) => {
        setPreviewValue(event.target.value);
        setOkEnabled(true);
    }

    const displayNode = (item) => {
        const prefix = item.entry?.mid !== 'VOLUME' && item.entry?.code && item.entry?.code !== '' && item.entry?.code !== '-' ? item.entry.code + ' ' : '';
        return (<TreeItem itemId={item.id} label={prefix + item.label}>
            {Array.isArray(item.children) && item.children.length > 0 &&
                item.children.map(child => displayNode(child))
            }
        </TreeItem>);
    };

    /*
        <div style={{height: '650px', width: '100%', position: 'relative'}} ref={editorContainer} >
                            
        </div>

        <Box sx={{height: '650px'}}>
            <ReactXMLViewer du={selectedDU} sx={{ height: '650px' }} />
        </Box>
    */

    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 1000,
                        maxWidth: 1200,
                        maxHeight: 950,
                        minHeight: 800,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent >
                <Box sx={{ height: '650px', width: '100%', position: 'relative'}}>
                    <SplitPane
                        style={{ minHeight: '10em',}}
                        split="vertical"
                        sizes={sizes}
                        onChange={setSizes}
                    >
                        <Pane minSize='30%' maxSize='100%'>
                            <SimpleTreeView
                                selectedItems={selectedItems}
                                onItemClick={handleItemClick}
                                expansionTrigger="iconContainer"
                                expandedItems={expandedItems}
                                onExpandedItemsChange={(event, itemids) => setExpandedItems(itemids)}
                            >
                                {Array.isArray(docModel) && docModel.length > 0 &&
                                    docModel.map(item => displayNode(item))
                                }
                            </SimpleTreeView>
                        </Pane>
                        <Box sx={{ height: '650px' }}>
                            <ReactXMLViewer du={selectedDU} onSelectionChange={handleDocSelectionChange} onDocumentLoad={handleDocLoad} value={viewerId} />
                        </Box>
                        
                    </SplitPane>
                </Box>
                {mode === 'LINK' &&
                    <Box>
                        <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Typography id="format-radio-buttons-group-label" sx={{ fontWeight: 'bold', width: '6.5em', color: 'black', paddingRight: 0 }}>Format:</Typography>
                            <RadioGroup
                                row
                                aria-labelledby="format-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={format}
                                onChange={handleFormatChange}
                            >
                                <FormControlLabel value="GEN" control={<Radio />} label="Generated" />
                                <FormControlLabel value="LIT" control={<Radio />} label="Literal" />
                                <FormControlLabel value="CUSTOM" control={<Radio />} label="Custom..." disabled />

                            </RadioGroup>
                        </FormControl>
                    </Box>
                }
                <Box sx={{paddingTop: 2}}>
                    <FormControl sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <FormLabel id="preview-label" sx={{fontWeight: 'bold', width: '6.5em', color: 'black', marginRight: 1}}>{previewLabel}:</FormLabel>
                        
                        <TextField fullWidth value={previewValue} onChange={handlePreviewChange} size="small" variant="outlined" aria-labelledby="preview-label" 
                            aria-readonly={previewReadOnly} 
                            slotProps={{
                                input: {
                                    readOnly: previewReadOnly,
                                    sx: {
                                        color: previewReadOnly ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.87)'
                                    }
                            }}} />
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 1 }}>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>
    
        );
    
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, pl: 1, pr: 1, pt: 2 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

var xItemId = null;
var xLinkend = null;
var xXmlDoc = null;
var xFormat = null;

function ExternalLinkChooserDialog (props) {
    const {
        title = 'Choose External Link Target',
        duType = 'DU',
        duMid = 'chapter',
        document,
        element,
        open,
        onSave,
        onCancel,
        ...other
    } = props;
    const [docList, setDocList] = useState([]); // list of all UCS Documents
    const [docModel, setDocModel] = useState([]); // tree containing all documents except the source document
    const [selectedNode, setSelectedNode] = useState(null);
    const [selectedDU, setSelectedDU] = useState(null); // only set when opening the editor
    const [selectedItems, setSelectedItems] = useState(null);
    const [expandedItems, setExpandedItems] = useState([]);
    const [okEnabled, setOkEnabled] = useState(false);
    const [sizes, setSizes] = useState(['100%', 'auto']);
    const [format, setFormat] = useState('LIT');
    const [previewValue, setPreviewValue] = useState('');
    const [previewLabel, setPreviewLabel] = useState('Label');
    const [previewReadOnly, setPreviewReadOnly] = useState(false);
    const [xmlContent, setXmlContent] = useState(null); // for now no links to inside DU on external links
    const [linkend, setLinkend] = useState('');
    const [viewerId, setViewerId] = useState(''); // set selected id in viewer
    const [location, setLocation] = useState('');
    const [tabIndex, setTabIndex] = useState(0);
    const [urlType, setUrlType] = useState('LINK');
    const [urlValue, setUrlValue] = useState('');
    const [urlLabel, setUrlLabel] = useState('');
    const [urlPrompt, setUrlPrompt] = useState('URL');
    const [waiting, setWaiting] = useState(false);

    // const editorContainer = useRef(null);
    const EMAIL_LABEL = 'Email Address';
    const LINK_LABEL = 'URL';
    const TEL_LABEL = 'Telephone Number';

    /*
    useEffect( () => {
        
        editorContainer.current.classList.add("react-container");
        const shadowRoot = editorContainer.current.attachShadow({ mode: "open" });
        const root = createRoot(shadowRoot);
        const editor = <ReactXMLEditor readOnly={true} showHeader={false} showToolbar={false} du={selectedDU} sx={{height: '650px'}}/>;
        root.render(editor);
        
    }, []);
    */

    useEffect(() => {
        // document in this case is the source document
        // should skip it
        if ( open && document ) {
            setDocModel([]);
            setSelectedDU(null);
            setSelectedNode(null);
            setSelectedItems(null);
            setXmlContent(null);
            setLinkend('');
            setViewerId('');
            setLocation('');
            setSizes(['100%', 'auto']);
            setOkEnabled(false);
            let params = '';
            if ( duType && duType.length > 0 ) {
                params = '?type=' + duType;
            }
            if ( duMid && duMid.length > 0 ) {
                if ( params === '' ) {
                    params = '?mid=' + duMid;
                } else {
                    params = params + '&mid=' + duMid;
                }
            }
            loadDocuments(document);
            /*
            let url = '/api/doc/tree/' + encodeURIComponent(document) + params;
            netGet(url)
                .then(response => response.json())
                .then(droot => {
                    if (droot) {
                        const model = [droot];
                        setDocModel(model);
                        setExpandedItems([droot.id]);
                        // setSelectedItems(null);
                        if ( iItemId ) {
                            const item = findItem(model, iItemId);
                            console.log('opening viewer... ' + iItemId);
                            setSelectedNode(item);
                            openXMLViewer(item);
                            console.log('setting viewer to ' + iLinkend);
                            setViewerId(iLinkend);
                        } else {
                            console.log('No selected item!');
                        }
                    }
                }).catch(error => {
                    console.log('Error fetching Document tree: ' + error);
                });
            */
        } else {
            setDocModel([]);
            setSelectedDU(null);
            setSelectedNode(null);
            setExpandedItems([]);
            setSelectedItems(null);
            setSizes(['100%', 'auto']);
            setXmlContent(null);
            setViewerId('');
            setLinkend('');
            setOkEnabled(false);
        }
    },[open,document,duType,duMid]);

    useEffect( () => {
        if ( element ) {
            if ( typeof element.text === 'string' && element.text.length > 0 ) {
                // this is a literal command 
                setFormat('LIT');
                iFormat = 'LIT';
                setPreviewValue(element.text);
                setUrlLabel(element.text);
                setPreviewReadOnly(false);
                setPreviewLabel('Label');
            } else {
                if ( element.attributes ) {
                    if ( element.attributes['preview']) {
                        setFormat('GEN');
                        iFormat = 'GEN';
                        setPreviewLabel('Preview');
                        setPreviewValue(element.attributes['preview']);
                        setPreviewReadOnly(true);
                    } 
                    

                }
            }
            xItemId = null;
            xLinkend = null;
            if ( element.attributes ) {
                if (element.attributes.linkend) {
                    setLinkend(element.attributes.linkend);
                    iLinkend = element.attributes.linkend;
                }
                if (element.attributes.location) {
                    setLocation(element.attributes.location);
                    const i = element.attributes.location.indexOf(':');
                    if ( i >= 0 ) {
                        const itemId = element.attributes.location.substring(i+1);
                        setSelectedItems(itemId);
                        // console.log('setting selectedItems: ' + itemId);
                        iItemId = itemId;
                    }
                }
                if (element.attributes['href'] && element.attributes.href.length > 0) {
                    setTabIndex(1);
                    const href = element.attributes.href;
                    if (href.startsWith('mailto:')) {
                        setUrlType('EMAIL');
                        setUrlPrompt(EMAIL_LABEL)
                        setUrlValue(href.substring(7));
                    } else if (href.startsWith('tel:')) {
                        setUrlType('TEL');
                        setUrlPrompt(TEL_LABEL);
                        setUrlValue(href.substring(4));
                    } else {
                        setUrlType('LINK');
                        setUrlPrompt(LINK_LABEL);
                        setUrlValue(href);
                    }
                } else {
                    setTabIndex(0);
                    setUrlType('LINK');
                    setUrlPrompt(LINK_LABEL);
                    setUrlValue('');
                }
            }
        }
    },[element]);

    const loadDocuments = (mydoc) => {
        netGet('/api/doc/roots?sort=alpha')
            .then(response => response.json())
            .then(docs => {
                if (Array.isArray(docs)) {
                    
                    const dd = [];
                    const dm = []
                    docs.forEach(doc => {
                        if ( doc.document !== mydoc ) {
                            doc['label'] = doc.title;
                            dd.push(doc);
                            dm.push(doc);
                        }
                    });
                    setDocList(dd);
                    setDocModel(dm);
                    // console.log('Got ' + dm.length + ' documents: ' + JSON.stringify(dm));
                }
            }).catch(error => {
                console.log('Error fetching document list: ' + error);
            });
    };

    const loadDocument = (docid) => {
        setWaiting(true);
        let url = '/api/doc/tree/' + encodeURIComponent(docid) + '?type=PSL' ;
            netGet(url)
                .then(response => response.json())
                .then(droot => {
                    if (droot) {
                        const model = [...docModel];
                        const index = model.findIndex(d => d.document === docid);
                        let item;
                        if (index >= 0) {
                            item = model[index];
                            // console.log('opening viewer... ' + iItemId);
                            setSelectedNode(item);
                            item['children'] = droot.children;
                            item['entry'] = droot.entry;
                        }
                        setDocModel(model);
                        if ( item?.id ) {
                            setExpandedItems([item.id]);
                        }
                        setWaiting(false);
                    }
                }).catch(error => {
                    console.log('Error fetching Document tree: ' + error);
                    setWaiting(false);
                });
    }

    const resetDocuments = () => {
        const dm = [...docList];
        dm.forEach( d => {
            d['children'] = null;
            d['entry'] = null;
        });
        setDocList(dm);
        setDocModel(dm);
    };

    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            const entry = selectedNode?.entry ? selectedNode.entry : {};
            const du = { 
                path: selectedNode?.rootPath + '/' + entry.contentPath,
                title: selectedNode?.label,
                prefix: entry.code && entry.code !== '' && entry.code !== '-' ? entry.code + ' ' : '',
                node: selectedNode,
            };
            const res = {
                type: format,                
            };
            if ( tabIndex == 0 ) {
                res.linkend = linkend;
                res.location = location;
                res.du = du;
                res.preview = previewValue;
            } else {
                res.type = 'HREF';
                res.preview = urlLabel;
                switch ( urlType ) {
                    case 'LINK':
                        res.href = urlValue;
                        break;
                    case 'EMAIL':
                        res.href = 'mailto:' + urlValue;
                        break;
                    case 'TEL':
                        res.href = 'tel:' + urlValue;
                        break;
                    default:
                        res.href = urlValue;
                        break;
                }
            }
            onSave(res);
        }
    }


    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const findItem = (items, id) => {
        if (Array.isArray(items)) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (id === item.id) {
                    return item;
                }
                const child = findItem(item.children, id);
                if (child) {
                    return child;
                }
            }
        }
        return undefined;
    }

    const openXMLViewer = (item) => {

        setSelectedDU(item);
        setSizes(['40%', 'auto']);
        /*
        if ( editorContainer.current ) {
            if (!editorContainer.current.classList.contains('react-container')) {
                editorContainer.current.classList.add('react-container');
                const shadowRoot = editorContainer.current.attachShadow({ mode: "open" });
                const xuiCSS = getXuiStylesheet();
                const xxeclientCSS = getXxeclientStylesheet();
                shadowRoot.adoptedStyleSheets = [xuiCSS, xxeclientCSS];
                const root = createRoot(shadowRoot);
                const editor =
                    <React.StrictMode>
                        <Provider store={store}>
                            <div style={{height: '650px', width: '600px', display: 'block'}}>
                                <ReactXMLViewer du={item} root={shadowRoot} />
                            </div>
                        </Provider>
                    </React.StrictMode>;
                root.render(editor);
            }
        }
        */
    };

    const closeXMLViewer = () => {
        setSelectedDU(null);
        setSizes(['100%', 'auto']);
    };

    const handleItemClick = (event, itemId) => {
        if (itemId === selectedItems) {
            setSelectedItems(null);
            setOkEnabled(false);
            setSelectedNode(null);
        } else {
            const item = findItem(docModel, itemId);
            
            if (item?.isDocRoot ||  item?.entry?.type === 'PSL') {
                setSelectedItems(itemId);
                setOkEnabled(true);
                setSelectedNode(item);
                // setLocation(item.document + ':' + item.id);
                
            } else {
                setSelectedItems(null);
                setSelectedNode(null);
                setOkEnabled(false);
                setLinkend('');
                setLocation('');
            }
            if ( format !== 'LIT') {
                computePreview(itemId, docModel);
            }
            if ( item?.isDocRoot && !item.entry ) {
                loadDocument(item.document);
            }
        }
        setOkEnabled(true);
    }


    // get the number of this element within its sibling of the same tag
    const getNumbering = (elem) => {
        let i = 1;
        const name = elem.localName;
        let prev = elem.previousElementSibling;
        while ( prev ) {
            if ( prev.localName === name ) {
                i++;
            }
            prev = prev.previousElementSibling;
        }
        return i;
    };

    const getTitle = (elem) => {
        // console.log('getTitle: ' + elem?.localName);
        if ( elem.localName === 'title' ) {
            return elem.textContent;
        }
        let child = elem.firstElementChild;
        while ( child ) {
            if ( child.localName === 'title' ) {
                // console.log('Found title child: ' + child.textContent);
                return child.textContent;
            }
            child = child.nextElementSibling;
        }
        if ( elem.localName === 'chapter' ) {
            // special case when title is in first topic
            // console.log('Found chapter: using topic...');
            const topic = elem.firstElementChild;
            if ( topic ) {
                return getTitle(topic);
            }
        }
        return null;

    };

    const computePreview = (id, items) => {
        // console.log('computePreview: ' + id + ' : ' + (xml !== null && xml !== undefined));
        const item = findItem(items, id);
        if ( item ) {
            const docItem = findItem(items, item.document);
            const docLabel = docItem ? (item.id === docItem.id ? '' : docItem.label + ': ') : '';
            const prefix = item.entry?.mid !== 'VOLUME' && item.entry?.code && item.entry?.code !== '' && item.entry?.code !== '-' ? item.entry.code + ' ' : '';
            const label = docLabel + prefix + item.label;
            setPreviewValue(label);
            const linkend = item.entry ? item.entry.id : item.id;
            const loc = item.document + ':' + linkend;
            console.log('Set location: ' + loc);
            setLocation(loc);
            setLinkend(linkend);
        }
        /*
        if ( xml && id !== '') {
            const target = xml.getElementById(id);
            if ( target ) {
                const code = [];
                let elem = target;
                while (elem) {
                    if (elem.localName === 'chapter') {
                        const c = elem.getAttribute('code');
                        if ( c ) {
                            code.push(c);
                        }
                    } else if ( elem.localName === 'topic' && elem.parentElement?.localName !== 'chapter') {
                        const c = getNumbering(elem);
                        if ( c ) {
                            code.push(c);
                        }
                    }
                    elem = elem.parentElement;
                }
                let num = '';
                if ( code.length > 0 ) {
                    code.reverse();
                    for(let i=0; i<code.length; i++ ) {
                        if ( i > 0 ) {
                            num = num + '.';
                        }
                        num = num + code[i];
                    }
                    num = num + ' ';
                }
                let t = getTitle(target);
                if ( !t ) {
                    t = '';
                }
                const p = 'See ' + num + t.replaceAll(/\s+/g,' ');
                // console.log('new preview value = ' + p);
                setPreviewValue(p);

            }
        } else {

        }
        */
    };

    const handleDocSelectionChange = (value) => {
        // console.log('Selected ID = ' + value);
        setLinkend(value);
        setOkEnabled(true);
        if ( iFormat === 'GEN' ) {
            // console.log('computing preview of ' + value);
            // console.log('XML content: ' + (iXmlDoc ? iXmlDoc.documentElement?.localName : 'null'));
            computePreview(value, iXmlDoc);
        } else {
            console.log('Not computing preview: ' + format);
        }
    };

    const handleDocLoad = (docxml) => {
        const xmlParser = new DOMParser();
        const xdoc = xmlParser.parseFromString(docxml, "application/xml");
        // const items = xmlDoc.getElementsByTagName('xxe-image-viewport');
        // setXmlContent(xmlDoc);
        xXmlDoc = xdoc;
        // console.log('New XML doc content loaded');
        const root = xdoc.documentElement;
        if ( root ) {
            if ( iLinkend ) {
                setViewerId(iLinkend);
                if ( iFormat === 'GEN' ) {
                    computePreview(iLinkend, xdoc);
                }
                iLinkend = null;
            } else {
                const did = root.getAttribute('id');
                if (did) {
                    setViewerId(did);
                    console.log('Selecting root: ' + did);
                    if (iFormat === 'GEN') {
                        computePreview(did, xdoc);
                    }
                }
            }
        }

    };

    const handleFormatChange = (event) => {
        setFormat(event.target.value);
        setOkEnabled(true);
        xFormat = event.target.value;
        // console.log('Set format to ' + event.target.value);
        if ( 'LIT' === event.target.value ) {
            setPreviewLabel('Label');
            setPreviewReadOnly(false);
        } else if ( 'GEN' === event.target.value ) {
            setPreviewLabel('Preview');
            setPreviewReadOnly(true);
            if ( selectedNode ) {
                const itemId = selectedNode.id;
                computePreview(itemId, docModel);
            }
            
        }
    };

    const handlePreviewChange = (event) => {
        setPreviewValue(event.target.value);
        setOkEnabled(true);
    }

    const displayNode = (item) => {
        const prefix = item.entry?.mid !== 'VOLUME' && item.entry?.code && item.entry?.code !== '' && item.entry?.code !== '-' ? item.entry.code + ' ' : '';
        return (<TreeItem itemId={item.id} label={prefix + item.label}
            slotProps={{
                label: {
                    sx: {
                        color: item.isDocRoot ? 'black' : 'rgba(0,0,0,0.75)'
                    }
                }
            }}
        >
            {Array.isArray(item.children) && item.children.length > 0 &&
                item.children.map(child => displayNode(child))
            }
        </TreeItem>);
    };

    const handleUrlTypeChange = (event) => {
        setUrlType(event.target.value);
        setOkEnabled(true);
        switch (event.target.value) {
            case 'LINK':
                setUrlPrompt('URL');
                break;
            case 'EMAIL':
                setUrlPrompt(EMAIL_LABEL);
                break;
            case 'TEL':
                setUrlPrompt(TEL_LABEL);
                break;
            default:
                setUrlPrompt(LINK_LABEL);
                break;
        }
    };

    const handleUrlValueChange = (event) => {
        setUrlValue(event.target.value);
        setOkEnabled(true);
    }

    const handleUrlLabelChange = (event) => {
        setUrlLabel(event.target.value);
        setOkEnabled(true);
    }

    const handleTabChange = (event, index) => {
        setTabIndex(index);
        setOkEnabled(true);
        resetDocuments();
    };

    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 1000,
                        maxWidth: 1200,
                        maxHeight: 950,
                        minHeight: 800,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabIndex} onChange={handleTabChange} aria-label="basic tabs example">
                        <Tab label="UCS Document" sx={{textTransform: 'none', fontSize: '105%', fontWeight: 'bold'}} {...a11yProps(0)} />
                        <Tab label="External URL" sx={{textTransform: 'none', fontSize: '105%', fontWeight: 'bold'}} {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={tabIndex} index={0} sx={{paddingLeft: 0}}>
                    <Box sx={{position: 'relative', height: '700px' }}>
                        <Box sx={{ height: '590px', width: '100%', position: 'relative'}}>
                            <SplitPane
                                style={{ minHeight: '10em', }}
                                split="vertical"
                                sizes={sizes}
                                onChange={setSizes}
                            >
                                <Pane minSize='30%' maxSize='100%' style={{overflowY: 'auto'}}>
                                    <SimpleTreeView
                                        selectedItems={selectedItems}
                                        onItemClick={handleItemClick}
                                        expansionTrigger="iconContainer"
                                        expandedItems={expandedItems}
                                        onExpandedItemsChange={(event, itemids) => setExpandedItems(itemids)}
                                    >
                                        {Array.isArray(docModel) && docModel.length > 0 &&
                                            docModel.map(item => displayNode(item))
                                        }
                                    </SimpleTreeView>
                                </Pane>
                                <Box sx={{ height: '590px' }}>
                                    {/* <ReactXMLViewer du={selectedDU} onSelectionChange={handleDocSelectionChange} onDocumentLoad={handleDocLoad} value={viewerId} /> */}
                                </Box>

                            </SplitPane>
                        </Box>
                        <Box>
                            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Typography id="format-radio-buttons-group-label" sx={{ fontWeight: 'bold', width: '6.5em', color: 'black', paddingRight: 0 }}>Format:</Typography>
                                <RadioGroup
                                    row
                                    aria-labelledby="format-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={format}
                                    onChange={handleFormatChange}
                                >
                                    <FormControlLabel value="GEN" control={<Radio />} label="Generated" />
                                    <FormControlLabel value="LIT" control={<Radio />} label="Literal" />
                                    <FormControlLabel value="CUSTOM" control={<Radio />} label="Custom..." disabled />

                                </RadioGroup>
                            </FormControl>
                        </Box>
                        <Box sx={{ paddingTop: 2 }}>
                            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <FormLabel id="preview-label" sx={{ fontWeight: 'bold', width: '6.5em', color: 'black', marginRight: 1 }}>{previewLabel}:</FormLabel>

                                <TextField fullWidth value={previewValue} onChange={handlePreviewChange} size="small" variant="outlined" aria-labelledby="preview-label"
                                    aria-readonly={previewReadOnly} 
                                    slotProps={{ 
                                        input: { 
                                            readOnly: previewReadOnly,
                                            sx: {
                                                color: previewReadOnly ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.87)'
                                            }
                                        } 
                                    }}  />
                            </FormControl>
                        </Box>
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel value={tabIndex} index={1}>
                    <Box sx={{ position: 'relative', height: '700px' }}>
                        <FormControl>
                            <Typography id="url-type-radio-buttons-group-label" sx={{ fontWeight: 'bold', color: 'black', paddingRight: 0 }}>Type</Typography>
                            <RadioGroup
                                sx={{paddingLeft: 3}}
                                aria-labelledby="url-type-radio-buttons-group-label"
                                name="url-type-radio-buttons-group"
                                value={urlType}
                                onChange={handleUrlTypeChange}
                            >
                                <FormControlLabel value="LINK" control={<Radio />} label="Link" />
                                <FormControlLabel value="EMAIL" control={<Radio />} label="Email" />
                                <FormControlLabel value="TEL" control={<Radio />} label="Telephone" />

                            </RadioGroup>
                        </FormControl>
                        <Box sx={{ paddingTop: 3, paddingRight: 2 }}>
                            <FormControl sx={{width: '100%'}}>
                                <FormLabel id="url-label" sx={{ fontWeight: 'bold',  color: 'black', marginRight: 1 }}>{urlPrompt}</FormLabel>

                                <TextField fullWidth value={urlValue} onChange={handleUrlValueChange} size="small" variant="outlined" aria-labelled="url-label"
                                    sx={{marginLeft: 3}} />
                            </FormControl>
                        </Box>
                        <Box sx={{ paddingTop: 4, paddingRight: 2 }}>
                            <FormControl sx={{width: '100%'}}>
                                <FormLabel id="url-label" sx={{ fontWeight: 'bold', color: 'black', marginRight: 1 }}>Label</FormLabel>

                                <TextField fullWidth value={urlLabel} onChange={handleUrlLabelChange} size="small" variant="outlined" aria-labelled="url-label"
                                    sx={{marginLeft: 3}} />
                            </FormControl>
                        </Box>
                    </Box>
                </CustomTabPanel>
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{pl: 2}}>
                    <CircularProgress size="1.5rem" sx={{contentVisibility: waiting ? 'visible' : 'hidden'}}/>
                </Box>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>
    
        );
    
}

export { InternalLinkChooserDialog, ExternalLinkChooserDialog };